module.exports = __webpack_public_path__ + "f7a64c03f5c8ef05aca288a8b75e6462.svg";